export default __webpack_public_path__ + "static/media/successIcon.2746270e.svg";